var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "color-picker-item",
      on: {
        click: function (e) {
          return _vm.showPicker(e)
        },
        mouseenter: _vm.onMouseEnter,
        mouseleave: _vm.onMouseLeave,
      },
    },
    [
      _c("label", { attrs: { for: "representativeBubbleColor" } }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _c("round-slider", {
        staticClass: "theme-color-slider",
        attrs: {
          value: _vm.getOpacityValueFromHex(),
          "start-angle": "0",
          "end-angle": "+360",
          "line-cap": "round",
          radius: "60",
          min: 0,
          max: 100,
          update: function (value) {
            return _vm.setOpacity(value)
          },
          rangeColor: _vm.rawColor,
          "read-only": !_vm.opacitySlider,
          step: 5,
          width: 10,
          circleShape: "half-top",
          lineCap: "butt",
          borderColor: "var(--color-border-default)",
          editableTooltip: false,
        },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "color-palette-circle",
        style: { "background-color": _vm.rawColor },
        on: {
          click: function (e) {
            return _vm.showPicker(e)
          },
        },
      }),
      _vm._v(" "),
      _c("a-input", {
        ref: "colorRef",
        staticClass: "theme-color-input v-hidden",
        attrs: { type: "color" },
        on: {
          click: function (e) {
            return _vm.showPicker(e, true)
          },
        },
        model: {
          value: _vm.color,
          callback: function ($$v) {
            _vm.color = $$v
          },
          expression: "color",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }